import { Module } from 'vuex';
import * as Actions from './action-types';
import MegaMenuItem from '../models/menu-items';
import { AccountInfo } from '@azure/msal-common';
import { IRootState } from './models/root-state.model';
import {
  PlantDetailDTO,
  EntrancePlantDetailDTO,
} from '@/../client-generator/generated-clients/plants';
import { UIStateModule } from './ui-state.store.module';

export const RootStateModule: Module<IRootState, IRootState> = {
  modules: {
    UI: UIStateModule,
  },
  state: {
    account: null,
    isLoading: false,
    currentPlant: null,
    selectedPlantId: null,
    menuItemsContextual: [],
    isSidebarExpanded: false,

    // TODO: remove this comment if we keep the state refactor
    currentEntrancePlant: null,
    selectedEntrancePlantId: null,
  },
  mutations: {
    [Actions.SET_ACCOUNT](state, account: AccountInfo) {
      state.account = account;
    },

    [Actions.SET_APP_LOADING](state, isLoading: boolean) {
      state.isLoading = isLoading;
    },

    [Actions.SET_SIDEBAR_EXPANDED](state, isExpanded: boolean) {
      state.isSidebarExpanded = isExpanded;
    },

    [Actions.SET_SELECTED_PLANT_ID](state, plantId: number | null) {
      state.selectedPlantId = plantId;
    },

    // TODO: remove this comment if we keep the state refactor
    [Actions.SET_SELECTED_ENTRANCE_PLANT_ID](state, plantId: number | null) {
      state.selectedEntrancePlantId = plantId;
    },

    [Actions.SET_SELECTED_PLANT](state, plant: PlantDetailDTO | null) {
      state.currentPlant = plant;
    },

    // TODO: remove this comment if we keep the state refactor
    [Actions.SET_SELECTED_ENTRANCE_PLANT](
      state,
      plant: EntrancePlantDetailDTO | null
    ) {
      state.currentEntrancePlant = plant;
    },

    [Actions.SET_CONTEXTUAL_MENU_ITEMS](state, menuItems: MegaMenuItem[]) {
      state.menuItemsContextual = menuItems;
    },
  },
  actions: {
    [Actions.SET_ACCOUNT]({ commit }, account: AccountInfo[]) {
      commit(Actions.SET_ACCOUNT, account);
    },

    [Actions.SET_APP_LOADING]({ commit }, isLoading: boolean) {
      commit(Actions.SET_APP_LOADING, isLoading);
    },

    [Actions.SET_SIDEBAR_EXPANDED]({ commit }, isExpanded: boolean) {
      commit(Actions.SET_SIDEBAR_EXPANDED, isExpanded);
    },

    [Actions.SET_SELECTED_PLANT]({ commit }, plant: PlantDetailDTO | null) {
      commit(Actions.SET_SELECTED_PLANT, plant);
    },

    // TODO: remove this comment if we keep the state refactor
    [Actions.SET_SELECTED_ENTRANCE_PLANT](
      { commit },
      plant: EntrancePlantDetailDTO | null
    ) {
      commit(Actions.SET_SELECTED_ENTRANCE_PLANT, plant);
    },

    [Actions.SET_SELECTED_PLANT_ID]({ commit }, plantId: number | null) {
      commit(Actions.SET_SELECTED_PLANT_ID, plantId);
    },

    // TODO: remove this comment if we keep the state refactor
    [Actions.SET_SELECTED_ENTRANCE_PLANT_ID](
      { commit },
      plantId: number | null
    ) {
      commit(Actions.SET_SELECTED_ENTRANCE_PLANT_ID, plantId);
    },

    [Actions.SET_CONTEXTUAL_MENU_ITEMS]({ commit }, menuItems: MegaMenuItem[]) {
      commit(Actions.SET_CONTEXTUAL_MENU_ITEMS, menuItems);
    },
  },
};
